import { render, staticRenderFns } from "./ProvidersEventShows.vue?vue&type=template&id=bb1c8a5c&lang=pug&"
import script from "./ProvidersEventShows.vue?vue&type=script&lang=js&"
export * from "./ProvidersEventShows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports